export default {
  namespaced: true,
  state: {
    menuMoveFlg: 0
  },
  mutations:{
    saveMenuMoveFlg(state){
      state.menuMoveFlg = 1
    },
    clearMenuMoveFlg(state){
      state.menuMoveFlg = 0
    }
  }
}